<template>
  <div>
    <b-row>

      <b-col md="12" class="d-flex align-items-center justify-content-between mb-1">
        <span class="text-muted" style="font-size:0.78rem;">Los campos con * son obligatorios</span>
        <b-link v-if="item && viewEdit" href="javascript:void(0);" class="small" @click="openFullEdit()">
          <b-icon icon="box-arrow-up-right" class="mr-1"></b-icon>
          Ver ficha completa
        </b-link>
      </b-col>

      <b-col md="6">
        <b-form-group label="Categoría *" label-size="sm">
          <b-form-select v-model="form.category_id" :options="options.categories" size="sm" :disabled="loading">
            <template #first>
              <b-form-select-option :value="0">— Seleccionar —</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Nombre *" label-size="sm">
          <b-form-input v-model="form.name" size="sm" placeholder="Nombre de la subcategoría"
                        ref="inputName" @keyup.enter.native="save()" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Orden *" label-size="sm">
          <b-form-input v-model="form.order" type="number" size="sm" min="0" :disabled="loading" />
        </b-form-group>
      </b-col>

      <b-col md="9" class="d-flex align-items-end pb-3">
        <b-form-checkbox v-model="form.show_print" :disabled="loading">
          Mostrar en impresión
        </b-form-checkbox>
      </b-col>

      <b-col md="12" class="d-flex justify-content-end mt-1">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$emit('cancel')" :disabled="loading">
          Cancelar
        </b-button>
        <b-button variant="primary" size="sm" @click="save()" :disabled="loading || !form.name.trim() || !form.category_id">
          <b-icon icon="check" class="mr-1"></b-icon>
          Guardar
        </b-button>
      </b-col>

    </b-row>
  </div>
</template>
<script>
  import serviceAPI from '../services'

  const emptyForm = () => ({ name: '', category_id: 0, order: 0, show_print: false })

  export default {
    props: {
      item: { type: Object, default: null },
      viewEdit: { type: String, default: '' },
      viewEditParamID: { type: String, default: '' },
    },
    data() {
      return { form: emptyForm(), loading: false, options: { categories: [] } }
    },
    watch: {
      item: {
        immediate: true,
        handler(val) {
          if (val) { this.loadForEdit(val.id) } else { this.form = emptyForm() }
        },
      },
    },
    mounted() {
      this.loadCategories()
      this.$nextTick(() => { if (this.$refs.inputName) this.$refs.inputName.focus() })
    },
    methods: {
      loadCategories() {
        serviceAPI.obtenerCategorias().then((r) => {
          this.options.categories = r.data.map((x) => ({ value: x.id, text: x.name }))
        })
      },
      loadForEdit(id) {
        this.loading = true
        serviceAPI.obtenerSubcategoria(id)
          .then((r) => {
            this.form = Object.assign(emptyForm(), r.data)
            this.form.name = this.form.name || ''
            this.form.category_id = this.form.category_id || 0
            this.form.order = this.form.order || 0
            this.form.show_print = this.form.show_print || false
          })
          .finally(() => { this.loading = false })
      },
      openFullEdit() {
        var params = {}
        params[this.viewEditParamID] = this.item.id
        window.open(this.$router.resolve({ name: this.viewEdit, params: params }).href, '_blank')
      },
      save() {
        if (!this.form.name.trim() || !this.form.category_id) return
        this.loading = true
        var isEdit = this.item && this.item.id
        var data = Object.assign({}, this.form, {
          name: this.form.name.trim(),
          category_id: this.form.category_id,
          order: this.form.order,
          show_print: this.form.show_print,
        })
        var call = isEdit
          ? serviceAPI.editarSubcategoria(Object.assign({}, data, { id: this.item.id }))
          : serviceAPI.agregarSubcategoria(data)
        call
          .then((r) => {
            this.$awn.success(isEdit ? 'Subcategoría actualizada' : 'Subcategoría creada')
            this.$emit('saved', r.data)
          })
          .catch(() => { this.$awn.alert('Error al guardar la subcategoría') })
          .finally(() => { this.loading = false })
      },
    },
  }
</script>
